import { ColorVariant } from "@/constants/theme";
import type { Theme } from "@/types/theme";

export function getHEXColorByColorVariant(
  theme: Pick<Theme, "colorSetup">,
  colorVariant: ColorVariant,
) {
  switch (colorVariant) {
    case ColorVariant.Black:
      return "#000000";

    case ColorVariant.White:
      return "#ffffff";

    case ColorVariant.Primary:
      return theme.colorSetup.brand.primary;

    case ColorVariant.Secondary:
      return theme.colorSetup.brand.secondary;

    case ColorVariant.Accent:
      return theme.colorSetup.brand.accent;

    case ColorVariant.BrandContrast:
      return theme.colorSetup.brand.contrast;

    case ColorVariant.Main:
      return theme.colorSetup.standard.main;

    case ColorVariant.Dark:
      return theme.colorSetup.standard.dark;

    case ColorVariant.Light:
      return theme.colorSetup.standard.light;

    case ColorVariant.StandardContrast:
      return theme.colorSetup.standard.contrast;

    case ColorVariant.Success:
      return theme.colorSetup.alert.success;

    case ColorVariant.Warning:
      return theme.colorSetup.alert.warning;

    case ColorVariant.Error:
      return theme.colorSetup.alert.error;

    case ColorVariant.Info:
      return theme.colorSetup.alert.info;

    case ColorVariant.Custom1:
      return theme.colorSetup.custom.color1;

    case ColorVariant.Custom2:
      return theme.colorSetup.custom.color2;

    case ColorVariant.Custom3:
      return theme.colorSetup.custom.color3;

    case ColorVariant.Custom4:
      return theme.colorSetup.custom.color4;

    default:
      return null;
  }
}
